// Basket add-on offers (snippets/cart-add-ons): the number box changes the
// price on the button ("Add $20 to cart", Michael 2026-10-10) and the saving.
const money = (cents) =>
  new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100)

const update = (e) => {
  const form = e.target.closest?.('[data-add-on]')
  if (!form || e.target.name !== 'quantity') return
  const n = Math.max(1, parseInt(e.target.value, 10) || 1)
  const unit = Number(form.dataset.unit)
  form.querySelector('[data-add-on-total]').textContent = money(unit * n)
  form.querySelector('[data-add-on-save]').textContent = money((Number(form.dataset.was) - unit) * n)
}
document.addEventListener('input', update)
document.addEventListener('change', update)
